import { safeLocalGet, safeLocalSet } from "@wags/tanstack-start/browser";

const KITS_HEARD_KEY = "wags:kits-received-text";

export function kitsHeardFromViewer(): boolean {
    return safeLocalGet(KITS_HEARD_KEY) === "1";
}

export function markKitsHeardFromViewer(): void {
    safeLocalSet(KITS_HEARD_KEY, "1");
}
